<template>
  <a v-if="isExternalLink" :href="to" v-bind="$attrs">
    <slot></slot>
  </a>
  <RouterLink v-else :to="to" v-bind="$attrs">
    <slot></slot>
  </RouterLink>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { RouterLink } from 'vue-router'

defineOptions({ inheritAttrs: false })

const props = defineProps<{
  to: string
}>()

const isExternalLink = computed(() => /^(?:[a-z][a-z\d+.-]*:|\/\/)/i.test(props.to))
</script>
